import { c as _c } from "react/compiler-runtime";
import { ExportDropdown } from "@components/common/export/export-dropdown";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useDateTime } from "@hooks/use-date-time";
import { downloadGroupData } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";
/** Dropdown to export groups in the file format selected by the user */
export function BulkExportGroups(t0) {
  const $ = _c(12);
  const {
    selectedGroups,
    areEntitiesSelected,
    buttonType
  } = t0;
  const {
    formatDate
  } = useDateTime();
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let t1;
  if ($[0] !== canAssignManagers || $[1] !== formatDate || $[2] !== selectedGroups) {
    t1 = async format => await downloadGroupData(selectedGroups, formatDate, format, canAssignManagers);
    $[0] = canAssignManagers;
    $[1] = formatDate;
    $[2] = selectedGroups;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const exportHandler = t1;
  let t2;
  if ($[4] !== areEntitiesSelected || $[5] !== selectedGroups.length) {
    t2 = {
      dataType: TableType.groups,
      numberOfEntities: selectedGroups.length,
      areEntitiesSelected
    };
    $[4] = areEntitiesSelected;
    $[5] = selectedGroups.length;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      success: "Successfully exported groups.",
      error: "Cannot export groups. Please try again."
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== buttonType || $[9] !== exportHandler || $[10] !== t2) {
    t4 = <ExportDropdown trackingProps={t2} exportHandler={exportHandler} toastMessage={t3} buttonTooltipText="Export groups" buttonType={buttonType} />;
    $[8] = buttonType;
    $[9] = exportHandler;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}